import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CAPService } from "../../../core/services/cap-service";
import * as $ from "jquery";
import { PagerService } from "../../../core/services/pager.service";
import { DatePipe } from "@angular/common";
// import { Router, ActivatedRoute } from "@angular/router";
import { IDropdownSettings } from "ng-multiselect-dropdown";

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: "app-deactivate-authcode",
  templateUrl: "./deactivate-authcode.component.html",
  styleUrls: ["./deactivate-authcode.component.css"],
})
export class DeactivateAuthcodeComponent implements OnInit {
  txtAuthcode = "";
  txtempid = "";
  txtwbse = "";
  txtEnterpriseID = "";
  txtsuperEnterpriseID = "";
  txtrequestid = "";
  txtstatus="";

  selectedAll;
  i = 0;
  Count = 0;
  maincount = 0;
  mainCountSingle = 0;
  CountAll = 1;
  //country="N";
  successfulData;
  public SelectedEnterpriseIDList;
  public SelectedEnterpriseIDInList;
  public SelectedEnterpriseIDList1;
  public StatusList;
  public dlstStatus='';
  public SelectedEnterpriseIDInList1;
  public LocationList;
  public selectedLocation = [];
  public showRecEIdlistbox;
  public showRecEIdlistbox1;
  public dropDownSettings: IDropdownSettings;
  dataLoader: boolean;
  DeActivateAuthChecked: boolean = false;
  gridData: any;
  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];
    RequestTypeList;
    public RequestType;
    Request;
    addModifyHostNamesForm: FormGroup;
    File: any;

  constructor(
    // private router: Router,
    private capservice: CAPService,private pagerService:PagerService,private changeDetectorRef: ChangeDetectorRef,private datePipe: DatePipe,private fb: FormBuilder) { }
  enterpriseID = this.capservice.enterpriseid;
  EmployeeNO = this.capservice.EmployeeNO;
  Country = this.capservice.country;
  Role = this.capservice.ReportRole;
  RoleReport = this.capservice.Role;
  country = this.RoleReport == "Regional Voice Admin" ? this.Country : "N";

  ngOnInit() {

    this.dataLoader = true;
    this.StatusList = [{name:"Not Deactivated"},{ name: "Deactivated"}]
    this.successfulData = {
      Id: "",
      RITMNumber: "",
      eId: "",
      managerEid: "",
      Facility: "",
      Country: "",
      authCodeId: "",
      FromDate: "",
      ToDate: "",
      wbsElement: "",
      authCodeDescription: "",
      checked: "",
      Date:"",
      Status:"",
    };
    this.dropDownSettings = {
      itemsShowLimit: 1,
      idField: "label_id",
      textField: "label",
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
    };
    this.addModifyHostNamesForm = this.fb.group({

      EnterpriseID: ['', Validators.required],
      EmployeeID: ['', Validators.required],
      domain: ['', Validators.required],
      hostName: ['', Validators.required],
      inputFile: '',
    })

    var MultiLocationListObj = { MultiLocationListArray: [] }; 
    this.capservice.GetVoiceAdminDetails(null,"AuthcodeLocation",null).subscribe(data =>{
      this.LocationList = data
      for (var i = 0; i < data.length; i++) {

          var location = {label_id: i , label: data[i].Facility }

          MultiLocationListObj.MultiLocationListArray.push(location);
        }
        this.LocationList = MultiLocationListObj.MultiLocationListArray;
      });
    this.RequestTypeList = [
      
      { name: 'Normal Deactivation Requests', },
      { name: 'Exit Deactivation Requests', }
    ]

   // this.getDEactivatedata();
    this.dataLoader = false;
  }

  RequestTypeEvent(event: any) {
    debugger;
    this.dataLoader = true;
    $('#txtAuthcode').val('');
    this.txtempid = '';
    this.txtwbse ='';
    this.txtEnterpriseID='';
    this.txtsuperEnterpriseID = '';
    this.txtrequestid = '';
    this.selectedLocation =[];
    this.dlstStatus="";
    this.showRecEIdlistbox1 = false;
    this.showRecEIdlistbox = false;
    this.Request = event.target.value;
    if(this.RoleReport == "Regional Voice Admin"|| this.RoleReport == "Global Admin")
    {
      if (this.Request == 'Normal Deactivation Requests') {    
       
        $("#AlertForAccessDeactivate").css("display", "none");
        $('#divDeActAuthCodeRequestsinputs').css("display", 'block');
        $('#divDeActAuthCodeExitButtons').css("display", 'block');
        $('#divDeActAuthCodeExitUpload').css("display", 'none');
        $('#Fileupload').css("display", 'none');
        // $('#divDeActAuthCodeRequests').css("display", 'block');
        // $('#divDeAuthcodeSubmit').css("display", 'block');
        this.DeActivateAuthcodeDetails();  
     
      }
      else if(this.Request == 'Exit Deactivation Requests') {  

        $("#AlertForAccessDeactivate").css("display", "none");
        $('#divDeActAuthCodeRequestsinputs').css("display", 'block');
        $('#divDeActAuthCodeExitButtons').css("display", 'none');
        $('#divDeActAuthCodeExitUpload').css("display", 'block');
        $('#Fileupload').css("display", 'block');
        // $('#divDeActAuthCodeRequests').css("display", 'block');
        // $('#divDeAuthcodeSubmit').css("display", 'none');
        this.ExitDeActivateAuthcodeDetails(); 
      }
    }
      else{
        $("#AlertForAccessDeactivate").css("display", "block");
        $('#divDeActAuthCodeRequestsinputs').css("display", 'none');
        $('#divDeActAuthCodeExitButtons').css("display", 'none');
        $('#divDeActAuthCodeExitUpload').css("display", 'none');
        $('#Fileupload').css("display", 'none');
      }
      this.dataLoader = false;
  }

  getDEactivatedata() {
    this.capservice.GetDeActivateAuthcodeRequests('DeActivate', this.EmployeeNO, this.country).subscribe(data=>{
     // this.dataLoader = true;
        if (data.length > 0) {
          this.successfulData = { DeActivateAuthcodes: data, selected: {} };
          this.allItems = data;
          this.setPage(1);
   //     this.dataLoader = false;
        }
    //  this.dataLoader = false;
      });
  }
  GetEnterpriseID() {
    if (this.txtEnterpriseID.length >= 3) {
      this.capservice
        .AutoPopulateGetEnterpriseIDList(this.txtEnterpriseID)
        .subscribe(
          (data) => {
            this.SelectedEnterpriseIDList = data;
          },
          (err) => {}
        );
      this.showRecEIdlistbox = true;
    } else {
      this.showRecEIdlistbox = false;
    }
  }
  PostEnterpriseID() {
    this.showRecEIdlistbox = false;
    if (this.SelectedEnterpriseIDInList != "") {
      this.txtEnterpriseID = this.SelectedEnterpriseIDInList[0];
      this.showRecEIdlistbox = false;
    }
  }
  GetEnterpriseID1() {
    if (this.txtsuperEnterpriseID.length >= 3) {
      this.capservice
        .AutoPopulateGetEnterpriseIDList(this.txtsuperEnterpriseID)
        .subscribe(
          (data) => {
            this.SelectedEnterpriseIDList1 = data;
          },
          (err) => {}
        );
      this.showRecEIdlistbox1 = true;
    } else {
      this.showRecEIdlistbox1 = false;
    }
  }
  PostEnterpriseID1() {
    this.showRecEIdlistbox1 = false;
    if (this.SelectedEnterpriseIDInList1 != "") {
      this.txtsuperEnterpriseID = this.SelectedEnterpriseIDInList1[0];
      this.showRecEIdlistbox1 = false;
    }
  }

  ShowData() {
    this.dataLoader = true;
    var Location ='';
    var Status='';
    if (($('#txtAuthcode').val() == "") && (this.txtempid == "") && (this.txtwbse == "") && 
    this.txtEnterpriseID == "" && this.txtsuperEnterpriseID == "" && 
    this.selectedLocation.length == 0 && this.txtrequestid == "" && 
    (this.dlstStatus == ""|| this.dlstStatus == "Select")) {      
      alert("Please select value to search");
          this.dataLoader=false;
       }
      else {
      // this.capservice.GetDeActivateAuthcodeRequests('SearchDeActivate', $('#txtAuthcode').val(), this.country).subscribe(data=>{
      //   if(data.length>0) {
      //     this.successfulData = { DeActivateAuthcodes: data, selected: {} }
      //     this.allItems=data;
      //     this.setPage(1);
          for (var i = 0; i < this.selectedLocation.length; i++) {
            Location = Location + ',' + this.selectedLocation[i].label
      }
      if(this.dlstStatus=="Deactivated")
      {
      Status="DeActivation";
      }
      if(this.dlstStatus=="Not Deactivated")
      {
       Status="Not DeActivation"
      }
      this.capservice
        .AuthCodeSearchRequest(
          "SearchDeActivate",
          $("#txtAuthcode").val(),
          this.txtempid,
          this.txtwbse,
          this.txtEnterpriseID,
          this.txtsuperEnterpriseID,
          Location,
          this.txtrequestid,
          Status
        )
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { DeActivateAuthcodes: data, selected: {} };
            this.allItems = data;
            this.setPage(1);
          } else {
            $("#txtAuthcode").val("");
            this.txtempid = "";
            this.txtwbse = "";
            this.txtEnterpriseID = "";
            this.txtsuperEnterpriseID = "";
            this.txtrequestid = "";
            this.dlstStatus = ""
            this.selectedLocation = [];
            this.showRecEIdlistbox1 = false;
            this.showRecEIdlistbox = false;
            alert("No Records Found");
            this.getDEactivatedata();
          }
        });
    }
        this.dataLoader=false;
  }
  ExitShowData() {
    debugger;
    this.dataLoader = true;
    var Location ='';
    var Status='';
    if (($('#txtAuthcode').val() == "") && (this.txtempid == "") && (this.txtwbse == "") && this.txtEnterpriseID == "" && this.txtsuperEnterpriseID == "" && this.selectedLocation.length == 0 && this.txtrequestid == "" && this.dlstStatus == "") {      
          alert("Please select value to search");
          this.dataLoader=false;
       }
      else {
          // this.capservice.GetDeActivateAuthcodeRequests('SearchDeActivate', $('#txtAuthcode').val(), this.country).subscribe(data=>{
          //   if(data.length>0) {
          //     this.successfulData = { DeActivateAuthcodes: data, selected: {} }
          //     this.allItems=data;
          //     this.setPage(1);
          for (var i = 0; i < this.selectedLocation.length; i++) {
            Location = Location + ',' + this.selectedLocation[i].label
        }
        if(this.dlstStatus=="Deactivated")
      {
      Status="DeActivation";
      }
      if(this.dlstStatus=="Not Deactivated")
      {
       Status="Not DeActivation"
      }
        this.capservice.AuthCodeSearchRequest('ExitSearchDeActivate', $('#txtAuthcode').val(),this.txtempid,this.txtwbse,this.txtEnterpriseID,this.txtsuperEnterpriseID,Location,this.txtrequestid,Status).subscribe(data=>{
          if (data.length > 0) {
            this.successfulData = { DeActivateAuthcodes : data, selected: { } }
            this.allItems=data;
            this.setPage(1);
            
            }
            else {
              $("#txtAuthcode").val("");
              this.txtempid = "";
              this.txtwbse = "";
              this.txtEnterpriseID = "";
              this.txtsuperEnterpriseID = "";
              this.txtrequestid = "";
              this.dlstStatus = ""
              this.selectedLocation = [];
              this.showRecEIdlistbox1 = false;
              this.showRecEIdlistbox = false;
              alert("No Records Found");
              //$('#divDeActAuthCodeRequests').css("display", 'none');
              this.dataLoader=false;

              }
          });
        }
        this.dataLoader=false;
  }
  setFile(event) {
    this.File = event.target.files[0];
  }
  

 UploadExitDeActivateAuthcode() {
   debugger;
  this.dataLoader = true;
  var orgfile = this.addModifyHostNamesForm.controls.inputFile.value;
    var ext = orgfile.split('.').pop().toLowerCase();        
      
      if (orgfile == '') {
        alert('Please upload the file');
        this.dataLoader = false;
        return;
    }
    if (ext != 'xls' && ext != 'xlsx') {
        alert('Please upload file with .xls or .xlsx extension only');
        $("#fileControl").val('');       
        this.dataLoader = false;
    }
    else {
        var str = "Deactivate"
        var formData = new FormData();
        formData.append('file', this.File);
        this.capservice.UploadExitDeActivateAuthcode(str,formData).subscribe(data => {
            this.addModifyHostNamesForm.controls.inputFile.setValue('');
            alert(data);
            this.ExitDeActivateAuthcodeDetails();
          // this.ExistData();
            this.dataLoader = false;
        })
    }
  }

  reload() {
    $("#txtAuthcode").val("");
    this.txtempid = "";
    this.txtwbse = "";
    this.txtEnterpriseID = "";
    this.txtsuperEnterpriseID = "";
    this.txtrequestid = "";
    this.dlstStatus = "";
    this.selectedLocation = [];
    this.showRecEIdlistbox1 = false;
    this.showRecEIdlistbox = false;
    this.selectedAll = false;

    this.DeActivateAuthcodeDetails();

    // this.capservice.GetDeActivateAuthcodeRequests('DeActivate', this.EmployeeNO, this.country).subscribe(data=>{
    //   if(data.length>0) {
    //     this.successfulData = { DeActivateAuthcodes: data, selected: {} }
    //     this.allItems=data;
    //     this.setPage(1);
    //   }
    // });
  }
  Exitreload() {
    $("#txtAuthcode").val('');
    this.txtempid = '';
    this.txtwbse ='';
    this.txtEnterpriseID='';
    this.txtsuperEnterpriseID = '';
    this.txtrequestid = '';
    this.dlstStatus = "";
    this.selectedLocation =[];
    this.showRecEIdlistbox1 = false;
    this.showRecEIdlistbox = false;
    this.selectedAll = false;
    

    this.ExitDeActivateAuthcodeDetails();

    // this.capservice.GetDeActivateAuthcodeRequests('DeActivate', this.EmployeeNO, this.country).subscribe(data=>{
    //   if(data.length>0) {
    //     this.successfulData = { DeActivateAuthcodes: data, selected: {} }
    //     this.allItems=data;
    //     this.setPage(1);
    //   }
    // });
  }

  DeSubmitData() {
    var message = '';
    var i=0;
    this.successfulData.DeActivateAuthcodes.forEach(DeActivateAuthcode => {
      if ($('input:checkbox:checked').length > 1) {
        this.maincount = this.successfulData.DeActivateAuthcodes.length;
      } else {
        this.mainCountSingle = $("input:checkbox:checked").length;
      }
      if (DeActivateAuthcode.checked) {
        i++;
        //this.capservice.AuthCodeDetails(DeActivateAuthcode.RITMNumber, DeActivateAuthcode.eId, "DeActivate", DeActivateAuthcode.Facility, DeActivateAuthcode.authCodeId,DeActivateAuthcode.managerEid).subscribe(data=>{
        this.capservice
          .AuthCodeDetails(
            DeActivateAuthcode.RITMNumber,
            DeActivateAuthcode.eId,
            "DeActivate",
            DeActivateAuthcode.Facility,
            DeActivateAuthcode.authCodeId,
            DeActivateAuthcode.managerEid,
            this.enterpriseID
          )
          .subscribe((data) => {
            if (data) {
              this.Count++;
              this.CountAll++;
              this.Depopup("True");
            }
          });
      }
      this.reload();
    });
    if (i == 0) {
      alert("Please Select Atleast One Record");
    }
  }
  ExportData() {
    var Location ='';
     var Status='';
    var ReportName = 'DeActivate_Authcode.xlsx';
    for (var i = 0; i < this.selectedLocation.length; i++) {
      Location = Location + ',' + this.selectedLocation[i].label
    }
    if(this.dlstStatus=="Deactivated")
    {
    Status="DeActivation";
    }
    if(this.dlstStatus=="Not Deactivated")
    {
     Status="Not DeActivation"
    }

    this.capservice
      .AuthCodeSearchRequestBulkDownload(
        "SearchDeActivate",
        $("#txtAuthcode").val(),
        this.txtempid,
        this.txtwbse,
        this.txtEnterpriseID,
        this.txtsuperEnterpriseID,
        Location,
        this.txtrequestid, 
        Status,
        
        
      )
      .subscribe(
        (data: Blob) => {
          //this.capservice.AuthCodeDetailsBulkDownload('DeActivate', null, this.country).subscribe((data:Blob) => {
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // for IE
            (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
            //this.loaderGif=false;
    }
      else{
        var link = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.download = ReportName;
            link.click();
            //this.loaderGif=false;
          }
        },
        function (x) {
          console.log(x);
          alert("Acknowledgement failed");
          this.loaderGif = false;
        }
      );
  }
  ExportCiscoData() {
    var ReportName = 'DeActiveAuthcode_Cisco.xlsx';
    this.capservice.AuthCodeDetailsBulkDownload('DeActiveCiscoAuthcode', null, this.country).subscribe((data:Blob) => {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob){ // for IE
        (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
            //this.loaderGif=false;
    }
      else{
        var link = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.download = ReportName;
            link.click();
            //this.loaderGif=false;
          }
        },
        function (x) {
          console.log(x);
          alert("Acknowledgement failed");
          this.loaderGif = false;
    })      
   
  }

  ExitExportData(){
    var Location ='';
    var ReportName = 'Exit_DeActivate_Authcode.xlsx';
    for (var i = 0; i < this.selectedLocation.length; i++) {
      Location = Location + ',' + this.selectedLocation[i].label
  }
  this.capservice.AuthCodeSearchRequestBulkDownload('ExitSearchDeActivate', $('#txtAuthcode').val(),this.txtempid,this.txtwbse,this.txtEnterpriseID,this.txtsuperEnterpriseID,Location,this.txtrequestid,this.dlstStatus).subscribe((data:Blob) => {
    //this.capservice.AuthCodeDetailsBulkDownload('DeActivate', null, this.country).subscribe((data:Blob) => {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob)
      { // for IE
        (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
        //this.loaderGif=false;
    }
      else{
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = ReportName;
        link.click();
        //this.loaderGif=false;
        }
    },function (x) {
        console.log(x);
        alert('Acknowledgement failed');
        this.loaderGif=false;
    })    
  }
  DeActivateAuthcodeDetails() {
    this.capservice.GetDeActivateAuthcodeRequests('DeActivate', this.EmployeeNO,this.country).subscribe(data=>{
      if (data.length > 0) {
        $('#divDeActAuthCodeRequests').css("display", 'block');
        this.successfulData = { DeActivateAuthcodes: data, selected: {} }
        this.allItems=data;
        this.setPage(1);
        this.dataLoader = false;
    }
    });
  }

  
  ExitDeActivateAuthcodeDetails() {
    debugger;
    this.capservice.GetDeActivateAuthcodeRequests('ExitDeActivate', this.EmployeeNO,this.country).subscribe(data=>{
     
    if (data.length > 0) 
    {
        $('#divDeActAuthCodeRequests').css("display", 'block');
        this.successfulData = { DeActivateAuthcodes: data, selected: {} }
          this.allItems = data;
          this.setPage(1);
        this.dataLoader = false;
    }
    else
    { 
      // this.capservice.GetDeActivateAuthcodeRequests('ExitDeActivate', this.EmployeeNO,this.country).subscribe(data=>{
      //   $('#divDeActAuthCodeRequests').css("display", 'block');
        alert("No Records Available");
        this.dataLoader = false;
      // });
        }
      });
  }

  Depopup(Status) {
    if (this.Count == this.mainCountSingle) {
      if (Status == "True") {
        this.DeActivateAuthcodeDetails();
        alert("Updated successfully");
      }
    } else if (this.CountAll == this.maincount) {
      if (Status == "True") {
        this.DeActivateAuthcodeDetails();
        alert("Updated successfully");
      }
    } else {
      this.DeActivateAuthcodeDetails();
    }
  }
  //checkall chk
  checkAll(isChecked) {
    this.selectedAll = isChecked;
    this.successfulData.DeActivateAuthcodes.forEach((DeActivateAuthcode) => {
      DeActivateAuthcode.checked = this.selectedAll;
    });
  }
  /*
checkAll(type, Ischecked) {
  if (type == 'DeActiveAuthCode') {
    if (Ischecked) {
      this.selectedAll = true;
      // this.successfulData.DeActivateAuthcodes.forEach(DeActivateAuthcode => {
      //   DeActivateAuthcode.checked = Ischecked;
      // });
      this.DeActivateAuthChecked=true;
    } 
    else {
      this.selectedAll = false;
      // this.successfulData.DeActivateAuthcodes.forEach(DeActivateAuthcode => {
      //   DeActivateAuthcode.checked = Ischecked;
      // });
      this.DeActivateAuthChecked=false;
    }
  }
}
singlechk(event: any)
 {
  this.DeActivateAuthChecked=false;
  event.target.DeActivateAuthChecked=true;
 }
*/
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.DeActivateAuthcodes = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    this.changeDetectorRef.detectChanges();
  }
}
